(function () {

    // ==========================================================
    // HORIZON PRODUCT-DETAILS STICKY LOCK
    // The Product Details column is sticky; the PPC card itself is not.
    // This keeps the card below Shopify Horizon's live header stack.
    // ==========================================================
    function getPpcRoot() {
      return document.querySelector('[data-ppc-root].is-sticky') ||
             document.querySelector('[data-ppc-root]');
    }

    function getPpcFloatingPanel() {
      var root = getPpcRoot();
      return root ? root.querySelector('[data-ppc-floating-panel]') : null;
    }

    function setPpcStickyTop() {
      var root = getPpcRoot();
      if (!root || window.innerWidth < 750) return;

      var details = root.closest('.product-details');
      if (!details) return;

      var pageStyle = getComputedStyle(document.body);
      var rawGroupHeight = pageStyle.getPropertyValue('--header-group-height').trim();
      var rawHeaderHeight = pageStyle.getPropertyValue('--header-height').trim();

      var groupHeight = parseFloat(rawGroupHeight);
      var headerHeight = parseFloat(rawHeaderHeight);

      if (!isFinite(groupHeight) || groupHeight <= 0) {
        groupHeight = isFinite(headerHeight) && headerHeight > 0 ? headerHeight : 60;
      }

      var offset = Math.max(groupHeight, 60);
      root.style.setProperty('--ppc-sticky-top', offset + 'px');

      details.style.setProperty(
        'top',
        'calc(' + offset + 'px + 8px)',
        'important'
      );
    }

    function repairPpcAncestors() {
      var panel = getPpcFloatingPanel();
      if (!panel) return;

      var p = panel.parentElement;
      while (p && p !== document.body) {
        var tag = p.tagName.toLowerCase();
        if (tag === 'main' || p.id === 'MainContent') break;

        var cs = getComputedStyle(p);
        var clipsY = cs.overflowY === 'hidden' || cs.overflowY === 'clip';
        var clipsX = cs.overflowX === 'hidden' || cs.overflowX === 'clip';
        var hasVerticalScroll = p.scrollHeight > p.clientHeight + 1;
        var hasHorizontalScroll = p.scrollWidth > p.clientWidth + 1;

        if (clipsY && !hasVerticalScroll) {
          p.style.setProperty('overflow-y', 'visible', 'important');
        }
        if (clipsX && !hasHorizontalScroll) {
          p.style.setProperty('overflow-x', 'visible', 'important');
        }

        p = p.parentElement;
      }
    }

    function togglePpcShadow() {
      var panel = getPpcFloatingPanel();
      if (!panel) return;

      if (window.scrollY > 20) {
        panel.classList.add('scrolled');
      } else {
        panel.classList.remove('scrolled');
      }
    }

    function initPpcFloating() {
      var root = getPpcRoot();
      var panel = getPpcFloatingPanel();
      if (!root || !panel) return;

      var details = root.closest('.product-details');

      if (details) {
        if (window.innerWidth >= 750) {
          details.classList.add('blakora-ppc-sticky-column');

          details.style.setProperty('position', 'sticky', 'important');
          details.style.setProperty(
            'top',
            'calc(var(--header-group-height, var(--header-height, 60px)) + 8px)',
            'important'
          );
          details.style.setProperty('align-self', 'flex-start', 'important');
          details.style.setProperty('overflow', 'visible', 'important');
          details.style.setProperty('height', 'max-content', 'important');
          details.style.setProperty('max-height', 'none', 'important');
          details.style.setProperty('z-index', '10', 'important');
        } else {
          details.classList.remove('blakora-ppc-sticky-column');
          details.style.removeProperty('position');
          details.style.removeProperty('top');
          details.style.removeProperty('align-self');
          details.style.removeProperty('overflow');
          details.style.removeProperty('height');
          details.style.removeProperty('max-height');
          details.style.removeProperty('z-index');
        }
      }

      repairPpcAncestors();
      setPpcStickyTop();
      togglePpcShadow();
      root.classList.add('ppc-floating-ready');
    }

    initPpcFloating();

    var ppcScrollTimer = null;
    window.addEventListener('scroll', function () {
      if (ppcScrollTimer) {
        window.cancelAnimationFrame(ppcScrollTimer);
      }

      ppcScrollTimer = window.requestAnimationFrame(function () {
        setPpcStickyTop();
        togglePpcShadow();
        ppcScrollTimer = null;
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      setPpcStickyTop();
      initPpcFloating();
    }, { passive: true });

    window.addEventListener('orientationchange', function () {
      setTimeout(initPpcFloating, 50);
    }, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var ppcHeaderGroup = document.querySelector('#header-group') ||
                           document.querySelector('.header-group') ||
                           document.querySelector('#header-component');

      if (ppcHeaderGroup) {
        new ResizeObserver(function () {
          setPpcStickyTop();
        }).observe(ppcHeaderGroup);
      }
    }

    document.addEventListener('shopify:section:load', function () {
      setTimeout(initPpcFloating, 0);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(initPpcFloating, 0);
    });
    document.addEventListener('shopify:block:deselect', function () {
      setTimeout(initPpcFloating, 0);
    });

    // ---------- HELPERS ----------
    function updateVariantInputsInComponent(component, variantId) {
      const forms = component.querySelectorAll('form[action*="/cart/add"]');
      forms.forEach(function(form) {
        const input = form.querySelector('[name="id"]');
        if (input && input.value !== variantId) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      component.querySelectorAll('[name="id"]:not(form *)').forEach(function(input) {
        if (input.value !== variantId) {
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function formatMoney(cents, moneyFormat, currencyStyle) {
      let formatted;
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        formatted = Shopify.formatMoney(cents, moneyFormat);
      } else {
        try {
          const symbol = moneyFormat.split('{{amount}}')[0].trim() || '$';
          formatted = symbol + (cents / 100).toFixed(2);
        } catch (_) {
          formatted = '$' + (cents / 100).toFixed(2);
        }
      }
      if (currencyStyle === 'rs_text' || currencyStyle === 'rupee_symbol') {
        // Keep the shop's number formatting (commas/decimals), just swap the symbol/prefix
        const numericPart = formatted.replace(/^[^\d]*/, '').trim();
        const prefix = currencyStyle === 'rs_text' ? 'Rs. ' : '₹';
        return prefix + numericPart;
      }
      return formatted;
    }

    function animateNumber(el, oldVal, newVal, duration, pad) {
      if (!el) return;
      const diff = newVal - oldVal;
      if (diff === 0) return;
      const startTime = performance.now();
      function format(n) {
        return pad ? String(n).padStart(2, '0') : String(n);
      }
      function tick(time) {
        const progress = Math.min((time - startTime) / duration, 1);
        const current = Math.round(oldVal + diff * progress);
        el.textContent = format(current);
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = format(newVal);
      }
      requestAnimationFrame(tick);
    }

    // ---------- TOAST SYSTEM ----------
    function showToast(component, message, duration) {
      const toast = component.querySelector('[data-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      toast.style.display = 'block';
      clearTimeout(toast._hideTimer);
      toast._hideTimer = setTimeout(function() {
        toast.classList.remove('is-visible');
        setTimeout(function() {
          toast.style.display = 'none';
        }, 300);
      }, duration || 2000);
    }

    // ---------- INIT FUNCTIONS ----------
    function initTabs(component) {
      const tabBtns = component.querySelectorAll('[data-tab]');
      const panels = component.querySelectorAll('[data-panel]');
      tabBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          const idx = btn.dataset.tab;
          tabBtns.forEach(function(b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function(p) {
            p.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          const panel = component.querySelector('[data-panel="' + idx + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    }

    function initWishlist(component) {
      const btn = component.querySelector('.ppc-bookmark');
      if (!btn) return;
      const productId = component.dataset.productId;
      const KEY = 'blakora_saved_products';
      let savedIds = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(savedIds)) savedIds = [];
      const isSaved = savedIds.includes(Number(productId));
      if (isSaved) {
        btn.classList.add('is-saved');
        btn.setAttribute('aria-pressed', 'true');
        const icon = btn.querySelector('svg');
        if (icon) icon.setAttribute('fill', 'currentColor');
      }
      btn.addEventListener('click', function() {
        let updated = JSON.parse(localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(updated)) updated = [];
        const idx = updated.indexOf(Number(productId));
        let saved = false;
        let toastMsg = '';
        if (idx > -1) {
          updated.splice(idx, 1);
          saved = false;
          toastMsg = 'Removed from wishlist';
        } else {
          updated.push(Number(productId));
          saved = true;
          toastMsg = 'Saved to wishlist';
        }
        localStorage.setItem(KEY, JSON.stringify(updated));
        btn.classList.toggle('is-saved', saved);
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        const icon = btn.querySelector('svg');
        if (icon) icon.setAttribute('fill', saved ? 'currentColor' : 'none');
        if (saved) {
          btn.classList.remove('is-pulsing');
          void btn.offsetWidth;
          btn.classList.add('is-pulsing');
          btn.addEventListener('animationend', function handler() {
            btn.classList.remove('is-pulsing');
            btn.removeEventListener('animationend', handler);
          });
        }
        showToast(component, toastMsg, 1800);
        component.dispatchEvent(new CustomEvent('wishlist:toggle', {
          bubbles: true,
          detail: { productId: productId, saved: saved }
        }));
      });
    }

    function initModal(component) {
      const trigger = component.querySelector('[data-size-guide]');
      const modal = component.querySelector('[data-size-guide-modal]');
      if (!trigger || !modal) return;
      const content = modal.querySelector('.ppc-modal-content');

      // A transform/filter/will-change on ANY ancestor (common with sticky headers,
      // smooth-scroll libraries, etc.) turns position:fixed into something relative
      // to that ancestor instead of the real viewport, so the popup ends up centered
      // on the page instead of the visible screen. Moving it to be a direct child of
      // <body> sidesteps that entirely, on both mobile and desktop.
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }

      function openModal() {
        modal.style.display = 'flex';
        if (content) {
          content.classList.remove('is-positioned');
          requestAnimationFrame(function() {
            content.classList.add('is-positioned');
          });
        }
      }

      function closeModal() {
        modal.style.display = 'none';
        if (content) content.classList.remove('is-positioned');
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
      modal.querySelectorAll('[data-modal-close]').forEach(function(el) {
        el.addEventListener('click', closeModal);
      });
      modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
      });

      // Inches / CM tab toggle inside the popup
      const unitTabs = modal.querySelectorAll('[data-size-unit-tab]');
      const unitPanels = modal.querySelectorAll('[data-size-unit-panel]');
      unitTabs.forEach(function(tabBtn) {
        tabBtn.addEventListener('click', function() {
          const unit = tabBtn.dataset.sizeUnitTab;
          unitTabs.forEach(function(b) { b.classList.remove('is-active'); });
          unitPanels.forEach(function(p) { p.classList.remove('is-active'); });
          tabBtn.classList.add('is-active');
          const panel = modal.querySelector('[data-size-unit-panel="' + unit + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    }

    // Shared measurement tooltip for size pills (desktop hover only)
    function initPillTooltip(component) {
      const tooltip = component.querySelector('[data-pill-tooltip]');
      if (!tooltip) return;
      const pills = component.querySelectorAll('[data-variant-id][data-measurement]');
      if (!pills.length) return;
      const container = tooltip.closest('.ppc-card') || component;

      function buildTooltipContent(text) {
        const parts = text.split('·').map(function(s) { return s.trim(); }).filter(Boolean);
        tooltip.innerHTML = '';
        if (parts.length > 1) {
          const grid = document.createElement('span');
          grid.className = 'ppc-pill-tooltip-grid';
          parts.forEach(function(p) {
            const cell = document.createElement('span');
            cell.textContent = p;
            grid.appendChild(cell);
          });
          tooltip.appendChild(grid);
        } else {
          tooltip.textContent = text;
        }
      }

      function showTooltip(pill) {
        const text = pill.dataset.measurement;
        if (!text) return;
        clearTimeout(tooltip._hideTimer);
        buildTooltipContent(text);
        tooltip.style.display = 'block';
        const pillRect = pill.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const tooltipWidth = tooltip.offsetWidth;
        const pillCenter = (pillRect.left - containerRect.left) + (pillRect.width / 2);
        let left = pillCenter - (tooltipWidth / 2);
        const maxLeft = container.offsetWidth - tooltipWidth - 4;
        if (left < 4) left = 4;
        if (left > maxLeft) left = maxLeft;
        const top = (pillRect.top - containerRect.top) - tooltip.offsetHeight - 14;
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';

        let arrowLeft = pillCenter - left;
        const arrowMargin = 12;
        if (arrowLeft < arrowMargin) arrowLeft = arrowMargin;
        if (arrowLeft > tooltipWidth - arrowMargin) arrowLeft = tooltipWidth - arrowMargin;
        tooltip.style.setProperty('--ppc-tooltip-arrow-left', arrowLeft + 'px');

        tooltip.classList.add('is-visible');
      }

      function hideTooltip() {
        tooltip.classList.remove('is-visible');
        clearTimeout(tooltip._hideTimer);
        tooltip._hideTimer = setTimeout(function() {
          tooltip.style.display = 'none';
        }, 200);
      }

      pills.forEach(function(pill) {
        pill.addEventListener('mouseenter', function() { showTooltip(pill); });
        pill.addEventListener('mouseleave', hideTooltip);
        pill.addEventListener('focus', function() { showTooltip(pill); });
        pill.addEventListener('blur', hideTooltip);
      });
    }

    function initVariants(component) {
      const pills = component.querySelectorAll('[data-variant-id]');
      const variantInput = component.querySelector('[data-variant-input]');
      const currentPriceEl = component.querySelector('[data-current-price]');
      const comparePriceEl = component.querySelector('[data-compare-price]');
      const addBtn = component.querySelector('[data-add-to-cart]');
      const buyBtn = component.querySelector('[data-buy-now]');
      const addLabel = component.querySelector('[data-add-label]');
      const inventoryWrap = component.querySelector('[data-inventory]');
      const inventoryLabel = component.querySelector('[data-inventory-label]');
      const inventoryDot = component.querySelector('[data-inventory-dot]');
      const moneyFormat = component.dataset.moneyFormat || '${{amount}}';
      const currencyStyle = component.dataset.currencyStyle || 'shop_default';
      const showInventorySetting = component.dataset.showInventory === 'true';
      const inventoryThreshold = parseInt(component.dataset.inventoryThreshold, 10) || 5;
      const inventoryMaxRef = parseInt(component.dataset.inventoryMaxRef, 10) || 10;
      const isCurrentProductPage = component.dataset.currentPageProduct === 'true';

      /*
       * RADIAL SIZE RING ANIMATION
       * - Always resets the selected size to an empty ring.
       * - Calculates the fill directly from the selected variant's inventory.
       * - Forces a browser reflow before starting the transition so the
       *   empty -> inventory animation works reliably after every click.
       * - Uses the SVG CSS property rather than only the presentation
       *   attribute, which is more reliable for CSS transitions.
       */
      function updateRingStockColor(pill) {
        const fill = pill.querySelector('.ppc-ring-fill');
        if (!fill) return;

        const inventory = Math.max(0, parseInt(pill.dataset.inventory, 10) || 0);
        const maxInventory = Math.max(
          1,
          parseInt(pill.dataset.ringMax, 10) || inventoryMaxRef
        );

        if (inventory <= 0 || inventory <= inventoryThreshold) {
          fill.style.setProperty('stroke', '#ef4444', 'important');
        } else {
          fill.style.setProperty('stroke', '#22c55e', 'important');
        }
      }

      function animateRing(pill) {
        const fill = pill.querySelector('.ppc-ring-fill');
        if (!fill) return;

        const circumference = parseFloat(fill.getAttribute('stroke-dasharray')) || 138.23;
        const inventory = Math.max(0, parseInt(pill.dataset.inventory, 10) || 0);
        const maxInventory = Math.max(1, parseInt(pill.dataset.ringMax, 10) || inventoryMaxRef);

        updateRingStockColor(pill);

        let percentage = inventory / maxInventory;
        if (percentage > 1) percentage = 1;

        const finalOffset = circumference - (circumference * percentage);

        // Store the calculated value as well, so it remains inspectable.
        fill.dataset.finalOffset = String(finalOffset);

        // Make sure this size is the only selected ring.
        pills.forEach(function(p) {
          if (p !== pill) {
            const otherFill = p.querySelector('.ppc-ring-fill');
            if (otherFill) {
              otherFill.classList.remove('animate');
              otherFill.style.transition = 'none';
              otherFill.style.strokeDashoffset = String(circumference);
            }
          }
        });

        // Start completely empty.
        fill.classList.remove('animate');
        fill.style.transition = 'none';
        fill.style.strokeDasharray = String(circumference);
        fill.style.strokeDashoffset = String(circumference);

        // Force layout so the browser commits the empty state first.
        void fill.getBoundingClientRect();

        requestAnimationFrame(function() {
          fill.classList.add('animate');
          fill.style.transition =
            'stroke 0.25s ease, stroke-dashoffset 0.8s cubic-bezier(0.65,0,0.35,1)';

          requestAnimationFrame(function() {
            fill.style.strokeDashoffset = String(finalOffset);
          });
        });
      }

      function clearError() {
        const errorEl = component.querySelector('[data-error-message]');
        if (!errorEl) return;
        errorEl.classList.remove('is-visible');
        errorEl.textContent = '';
      }

      function selectVariant(pill, isUserAction) {
        const id = pill.dataset.variantId;
        const available = pill.dataset.available === 'true';
        const price = parseInt(pill.dataset.price, 10) || 0;
        const compare = parseInt(pill.dataset.compare, 10) || 0;
        const inventory = parseInt(pill.dataset.inventory, 10) || 0;
        const inventoryManaged = pill.dataset.inventoryManaged === 'shopify';

        pills.forEach(function(p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');

        if (variantInput) variantInput.value = id;
        updateVariantInputsInComponent(component, id);

        if (currentPriceEl) {
          const oldText = currentPriceEl.textContent;
          const newPrice = formatMoney(price, moneyFormat, currencyStyle);
          if (oldText !== newPrice) {
            currentPriceEl.style.opacity = '0';
            currentPriceEl.style.transform = 'translateY(-6px)';
            currentPriceEl.style.filter = 'blur(4px)';
            setTimeout(function() {
              currentPriceEl.textContent = newPrice;
              currentPriceEl.style.opacity = '1';
              currentPriceEl.style.transform = 'translateY(0)';
              currentPriceEl.style.filter = 'blur(0)';
            }, 120);
          } else {
            currentPriceEl.textContent = newPrice;
          }
        }
        if (comparePriceEl) {
          if (compare > price) {
            comparePriceEl.textContent = formatMoney(compare, moneyFormat, currencyStyle);
            comparePriceEl.style.display = 'inline';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        [addBtn, buyBtn].forEach(function(btn) {
          if (btn) btn.disabled = !available;
        });
        if (addLabel) {
          addLabel.textContent = available
            ? component.dataset.addText || 'Add to Bag'
            : component.dataset.soldOutText || 'Sold Out';
        }

        if (inventoryWrap && inventoryLabel && inventoryDot) {
          const showRow = showInventorySetting && inventoryManaged && inventory > 0;
          inventoryWrap.style.display = showRow ? '' : 'none';
          if (showRow) {
            const isLow = inventory <= inventoryThreshold;
            const isFull = inventory >= inventoryMaxRef;
            inventoryDot.classList.toggle('is-low', isLow);
            inventoryDot.classList.toggle('is-full', !isLow && isFull);
            let template = isLow
              ? component.dataset.inventoryLowText || 'only [quantity] left in [size]'
              : component.dataset.inventoryInStockText || 'In stock [quantity]';
            const sizeLabel = pill.dataset.optionValue || '';
            const existingNumber = inventoryLabel.querySelector('.inventory-number');
            const oldNum = existingNumber ? (parseInt(existingNumber.textContent, 10) || inventory) : inventory;

            // Use the selected size's configured full-stock reference.
            const sizeRingMax = parseFloat(pill.dataset.ringMax);
            const displayMax = Number.isFinite(sizeRingMax) && sizeRingMax > 0
              ? sizeRingMax
              : inventoryMaxRef;

            const qtyHtml = '<span class="inventory-number">' + String(inventory).padStart(2, '0') + '</span>'
              + '<span class="inventory-max">/' + String(displayMax).padStart(2, '0') + '</span>';

            // If the merchant entered only "In stock", still show the stock count.
            if (!template.includes('[quantity]')) {
              template = template + ' [quantity]';
            }

            const newHtml = template.replace('[quantity]', qtyHtml).replace('[size]', sizeLabel);
            inventoryLabel.innerHTML = newHtml;
            const newNumber = inventoryLabel.querySelector('.inventory-number');
            if (newNumber && oldNum !== inventory) {
              newNumber.textContent = String(oldNum).padStart(2, '0');
              animateNumber(newNumber, oldNum, inventory, 600, true);
            }
          } else {
            inventoryLabel.textContent = '';
          }
        }

        clearError();

        if (isUserAction) {
          animateRing(pill);
          if (isCurrentProductPage) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', id);
            window.history.replaceState({}, '', url);
          }
          component.dispatchEvent(new CustomEvent('variant:changed', {
            bubbles: true,
            detail: { variantId: id }
          }));
        }
      }

      pills.forEach(function(pill) {
        pill.addEventListener('click', function() {
          if (pill.disabled) return;
          selectVariant(pill, true);
        });
      });

      const selectedPill = component.querySelector('.ppc-pill.is-selected, .ppc-size-ring.is-selected');
      if (selectedPill) {
        selectVariant(selectedPill, false);
        if (selectedPill.querySelector('.ppc-ring-fill')) {
          requestAnimationFrame(function() { animateRing(selectedPill); });
        }
      } else if (pills.length) {
        const firstAvailable = Array.from(pills).find(function(p) { return p.dataset.available === 'true'; });
        if (firstAvailable) {
          selectVariant(firstAvailable, false);
          if (firstAvailable.querySelector('.ppc-ring-fill')) {
            requestAnimationFrame(function() { animateRing(firstAvailable); });
          }
        }
      }

      component._selectVariant = selectVariant;
    }

    function initCart(component) {
      const form = component.querySelector('.ppc-form');
      const addBtn = component.querySelector('[data-add-to-cart]');
      const buyBtn = component.querySelector('[data-buy-now]');
      const addLabel = component.querySelector('[data-add-label]');
      const spinner = component.querySelector('[data-spinner]');
      const errorEl = component.querySelector('[data-error-message]');
      const variantInput = component.querySelector('[data-variant-input]');
      const pills = component.querySelectorAll('[data-variant-id]');
      const SUCCESS_HOLD = parseInt(component.dataset.successHold, 10) || 500;

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.classList.add('is-visible');
      }
      function clearError() {
        if (!errorEl) return;
        errorEl.classList.remove('is-visible');
        errorEl.textContent = '';
      }

      async function addToCart(redirectToCheckout) {
        clearError();
        const id = variantInput ? variantInput.value : null;
        if (!id) {
          showError('No variant selected');
          return;
        }

        const originalLabel = addLabel ? addLabel.textContent : '';
        if (addBtn) { addBtn.disabled = true; }
        if (buyBtn) { buyBtn.disabled = true; }
        pills.forEach(function(p) {
          p.dataset.wasDisabled = p.disabled ? 'true' : 'false';
          p.disabled = true;
        });
        if (addLabel) addLabel.textContent = component.dataset.addingText || 'Adding…';
        if (spinner) spinner.style.display = 'inline-block';
        component.classList.add('is-loading');

        let fetchSuccess = false;
        let errorMsg = '';

        try {
          let sectionId = null;
          const selectors = [
            '[data-drawer]',
            '[data-section-id*="cart"]',
            '#cart-drawer',
            '#CartDrawer',
            '[data-cart-drawer]',
            '.cart-drawer'
          ];
          for (const sel of selectors) {
            const el = document.querySelector(sel);
            if (el) {
              sectionId = el.dataset.sectionId || el.id.replace('shopify-section-', '');
              if (sectionId) break;
            }
          }
          if (!sectionId) {
            const fallback = document.querySelector('[data-section-id*="cart"]');
            if (fallback) sectionId = fallback.dataset.sectionId;
          }

          const payload = {
            items: [{ id: Number(id), quantity: 1 }]
          };
          if (sectionId) {
            payload.sections = [sectionId];
            payload.sections_url = window.location.pathname;
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          });
          const data = await res.json();
          if (!res.ok) {
            let msg = data.description || data.message || component.dataset.unavailableText || 'Error adding item';
            if (res.status === 422) {
              if (msg.includes('unavailable')) msg = 'This variant is currently unavailable.';
              else if (msg.includes('sold out')) msg = 'This variant is sold out.';
            }
            throw new Error(msg);
          }
          fetchSuccess = true;
          component.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { item: data } }));

          if (sectionId && data.sections && data.sections[sectionId]) {
            const wrapper = document.getElementById('shopify-section-' + sectionId);
            if (wrapper) {
              wrapper.innerHTML = data.sections[sectionId];
              document.dispatchEvent(new CustomEvent('section:updated', {
                bubbles: true,
                detail: { sectionId: sectionId }
              }));
            }
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          }

          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }

        } catch (err) {
          errorMsg = err.message || component.dataset.unavailableText || 'Something went wrong';
          fetchSuccess = false;
        }

        if (!redirectToCheckout) {
          if (fetchSuccess) {
            const targetBtn = addBtn || buyBtn;
            targetBtn.classList.add('ppc-success');
            setTimeout(function() {
              targetBtn.classList.remove('ppc-success');
              if (addBtn) { addBtn.disabled = false; }
              if (buyBtn) { buyBtn.disabled = false; }
              pills.forEach(function(p) {
                p.disabled = p.dataset.wasDisabled === 'true';
                delete p.dataset.wasDisabled;
              });
              const selected = component.querySelector('.ppc-pill.is-selected');
              const stillAvailable = selected ? selected.dataset.available === 'true' : true;
              if (addBtn) addBtn.disabled = !stillAvailable;
              if (buyBtn) buyBtn.disabled = !stillAvailable;
              if (addLabel) addLabel.textContent = originalLabel;
              if (spinner) spinner.style.display = 'none';
              component.classList.remove('is-loading');
            }, SUCCESS_HOLD);
          } else {
            showError(errorMsg);
            if (addBtn) { addBtn.disabled = false; }
            if (buyBtn) { buyBtn.disabled = false; }
            pills.forEach(function(p) {
              p.disabled = p.dataset.wasDisabled === 'true';
              delete p.dataset.wasDisabled;
            });
            const selected = component.querySelector('.ppc-pill.is-selected');
            const stillAvailable = selected ? selected.dataset.available === 'true' : true;
            if (addBtn) addBtn.disabled = !stillAvailable;
            if (buyBtn) buyBtn.disabled = !stillAvailable;
            if (addLabel) addLabel.textContent = originalLabel;
            if (spinner) spinner.style.display = 'none';
            component.classList.remove('is-loading');
          }
        }
      }

      if (form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          addToCart(false);
        });
      }
      if (buyBtn) {
        buyBtn.addEventListener('click', function() {
          addToCart(true);
        });
      }
    }

    // ---------- ORA PULSE (live activity custom element) ----------
    const OP_ALL_SIZES = ['S', 'M', 'L', 'XL'];

    function opGetAttr(el, key, fallback) {
      const val = el.getAttribute(key);
      if (val === null || val === '') return fallback;
      if (val === 'true') return true;
      if (val === 'false') return false;
      if (!isNaN(Number(val)) && val.trim() !== '') return Number(val);
      return val;
    }

    function opHashCode(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash |= 0;
      }
      return Math.abs(hash);
    }

    function opFlipNumber(container, newStr) {
      if (!container) return;
      const prevStr = container.dataset.flipVal || '';
      container.dataset.flipVal = newStr;
      const len = Math.max(prevStr.length, newStr.length, 1);
      const oldPadded = prevStr.padStart(len, '\u00A0');
      const newPadded = newStr.padStart(len, '\u00A0');
      container.innerHTML = '';

      for (let i = 0; i < len; i++) {
        const oldCh = oldPadded[i];
        const newCh = newPadded[i];
        const col = document.createElement('span');
        col.className = 'op-flip-col';
        const track = document.createElement('span');
        track.className = 'op-flip-track';

        const isDigitPair = /[0-9]/.test(oldCh) && /[0-9]/.test(newCh);
        if (!isDigitPair || oldCh === newCh || prevStr === '') {
          const only = document.createElement('span');
          only.textContent = newCh;
          track.appendChild(only);
          col.appendChild(track);
          container.appendChild(col);
          continue;
        }

        const goingUp = Number(newCh) > Number(oldCh);
        const a = document.createElement('span');
        const b = document.createElement('span');
        if (goingUp) {
          a.textContent = oldCh;
          b.textContent = newCh;
          track.appendChild(a);
          track.appendChild(b);
          track.style.transform = 'translateY(0)';
          col.appendChild(track);
          container.appendChild(col);
          requestAnimationFrame(() => {
            track.style.transition = 'transform 0.5s cubic-bezier(0.34,1.35,0.64,1)';
            track.style.transform = 'translateY(-1em)';
          });
        } else {
          a.textContent = newCh;
          b.textContent = oldCh;
          track.appendChild(a);
          track.appendChild(b);
          track.style.transform = 'translateY(-1em)';
          col.appendChild(track);
          container.appendChild(col);
          requestAnimationFrame(() => {
            track.style.transition = 'transform 0.5s cubic-bezier(0.34,1.35,0.64,1)';
            track.style.transform = 'translateY(0)';
          });
        }
      }
    }

    class OpSpringPoint {
      constructor(options = {}) {
        this.stiffness = options.stiffness || 100;
        this.damping = options.damping || 12;
        this.x = options.x || 0;
        this.y = options.y || 0;
        this.vx = 0;
        this.vy = 0;
        this.targetX = this.x;
        this.targetY = this.y;
        this._animId = null;
        this._lastTimestamp = 0;
        this._resolve = null;
        this.onUpdate = options.onUpdate || null;
      }

      setTarget(x, y, immediate = false) {
        this.targetX = x;
        this.targetY = y;
        if (immediate) {
          this.x = x;
          this.y = y;
          this.vx = 0;
          this.vy = 0;
          this._fireUpdate();
          if (this._animId) {
            cancelAnimationFrame(this._animId);
            this._animId = null;
          }
          return Promise.resolve();
        }
        if (!this._animId) {
          this._lastTimestamp = performance.now();
          this._animId = requestAnimationFrame(this._step.bind(this));
        }
        return new Promise((resolve) => { this._resolve = resolve; });
      }

      _step(timestamp) {
        const dt = Math.min((timestamp - this._lastTimestamp) / 1000, 0.05);
        this._lastTimestamp = timestamp;

        const fx = (this.targetX - this.x) * this.stiffness;
        const fy = (this.targetY - this.y) * this.stiffness;
        const dx = -this.vx * this.damping;
        const dy = -this.vy * this.damping;
        this.vx += (fx + dx) * dt;
        this.vy += (fy + dy) * dt;
        this.x += this.vx * dt;
        this.y += this.vy * dt;

        const diff = Math.hypot(this.targetX - this.x, this.targetY - this.y);
        const speed = Math.hypot(this.vx, this.vy);
        if (diff < 0.05 && speed < 0.05) {
          this.x = this.targetX;
          this.y = this.targetY;
          this.vx = 0;
          this.vy = 0;
          this._fireUpdate();
          this._animId = null;
          if (this._resolve) {
            this._resolve();
            this._resolve = null;
          }
          return;
        }
        this._fireUpdate();
        this._animId = requestAnimationFrame(this._step.bind(this));
      }

      _fireUpdate() {
        if (this.onUpdate) {
          this.onUpdate(this.x, this.y);
        }
      }
    }

    function opDistribute(total, rawWeights, sizes) {
      if (sizes.length === 0) return {};

      const weightSum = sizes.reduce((a, s) => a + (rawWeights[s] || 0), 0);
      const weights = {};
      if (weightSum <= 0) {
        sizes.forEach((s) => { weights[s] = 1 / sizes.length; });
      } else {
        sizes.forEach((s) => { weights[s] = (rawWeights[s] || 0) / weightSum; });
      }

      const raw = sizes.map((s) => total * weights[s]);
      const floors = raw.map(Math.floor);
      const used = floors.reduce((a, b) => a + b, 0);
      const remainder = total - used;
      const order = raw
        .map((v, i) => ({ i, frac: v - floors[i] }))
        .sort((a, b) => b.frac - a.frac);
      for (let k = 0; k < remainder; k++) floors[order[k].i] += 1;
      const out = {};
      sizes.forEach((s, i) => { out[s] = Math.max(0, floors[i]); });
      return out;
    }

    function opSmoothPath(pts) {
      let d = 'M' + pts[0][0] + ',' + pts[0][1];
      for (let i = 0; i < pts.length - 1; i++) {
        const p0 = pts[i], p1 = pts[i + 1];
        const mx = (p0[0] + p1[0]) / 2;
        d += ' Q' + mx + ',' + p0[1] + ' ' + mx + ',' + ((p0[1] + p1[1]) / 2);
        d += ' Q' + mx + ',' + p1[1] + ' ' + p1[0] + ',' + p1[1];
      }
      return d;
    }

    class OraPulse extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        try {
          this.config = {
            minTotal: opGetAttr(this, 'data-min-total', 8),
            maxTotal: opGetAttr(this, 'data-max-total', 70),
            refreshInterval: opGetAttr(this, 'data-refresh-interval', 3000),
            liveLabel: opGetAttr(this, 'data-live-label', 'live'),
            pausedLabel: opGetAttr(this, 'data-paused-label', 'paused'),
            demandLabel: opGetAttr(this, 'data-demand-label', 'demand'),
            mostSelectedLabel: opGetAttr(this, 'data-most-selected-label', 'top pick'),
            soldOutLabel: opGetAttr(this, 'data-sold-out-label', 'revive soon'),
            soldOutMinTotal: opGetAttr(this, 'data-sold-out-min-total', 1),
            soldOutMaxTotal: opGetAttr(this, 'data-sold-out-max-total', 5),
            showFeed: opGetAttr(this, 'data-show-feed', false),
            weights: {
              S: opGetAttr(this, 'data-weight-s', 24) / 100,
              M: opGetAttr(this, 'data-weight-m', 38) / 100,
              L: opGetAttr(this, 'data-weight-l', 26) / 100,
              XL: opGetAttr(this, 'data-weight-xl', 12) / 100,
            },
            productId: opGetAttr(this, 'data-product-id', 0),
          };

          const hasSizeOption = opGetAttr(this, 'data-has-size-option', false);
          const rawAvailable = (this.getAttribute('data-available-sizes') || '').trim();
          if (!hasSizeOption) {
            this.availableSizes = OP_ALL_SIZES.slice();
          } else {
            this.availableSizes = rawAvailable
              ? rawAvailable.split(',').map((s) => s.trim()).filter((s) => OP_ALL_SIZES.includes(s))
              : [];
          }
          this.isSoldOut = hasSizeOption && this.availableSizes.length === 0;

          this.els = {
            line: this.querySelector('.op-line'),
            area: this.querySelector('.op-area'),
            dot: this.querySelector('.op-dot'),
            total: this.querySelector('.op-total-flip'),
            liveLabel: this.querySelector('.op-live-label'),
            pct: this.querySelector('.op-pct-flip'),
            demandLabel: this.querySelector('.op-demand-label'),
            hotSize: this.querySelector('.op-hot-size'),
            mostSelectedLabel: this.querySelector('.op-most-selected-label'),
            sizesRow: this.querySelector('.op-sizes-row'),
            feed: this.querySelector('.op-feed'),
            toggleBtn: this.querySelector('.op-toggle'),
          };

          if (this.els.liveLabel) this.els.liveLabel.textContent = this.config.liveLabel;
          if (this.els.demandLabel) this.els.demandLabel.textContent = this.config.demandLabel;
          if (this.els.mostSelectedLabel) {
            this.els.mostSelectedLabel.textContent = this.isSoldOut ? 'status' : this.config.mostSelectedLabel;
          }

          const seed = this.config.productId || 0;
          const hash = seed ? opHashCode(seed.toString()) : 0;
          const effMin = this.isSoldOut ? this.config.soldOutMinTotal : this.config.minTotal;
          const effMax = this.isSoldOut ? this.config.soldOutMaxTotal : this.config.maxTotal;
          const range = effMax - effMin;
          const base = effMin + (hash % (range + 1));

          this.state = {
            total: base,
            prevTotal: base,
            pct: 0,
            history: new Array(7).fill(0).map((_, i) => {
              const offset = (hash + i * 31) % 40;
              return 6 + (offset / 40) * 22;
            }),
          };
          this.state.prevTotal = this.state.total;

          this.animators = {
            dot: new OpSpringPoint({
              stiffness: 100,
              damping: 12,
              x: 0,
              y: 0,
              onUpdate: (x, y) => {
                if (this.els.dot) {
                  this.els.dot.setAttribute('cx', x);
                  this.els.dot.setAttribute('cy', y);
                }
              }
            }),
          };

          this._sizeElements = new Map();
          this._sizeFlipEls = new Map();

          this._isIntersecting = false;
          this._isTabVisible = !document.hidden;
          this._userPaused = false;
          this._loopRunning = false;

          this.render(true);

          if (this.els.toggleBtn) {
            this.els.toggleBtn.addEventListener('click', () => {
              this._userPaused = !this._userPaused;
              this.els.toggleBtn.setAttribute('aria-pressed', String(this._userPaused));
              this.els.toggleBtn.setAttribute(
                'aria-label',
                this._userPaused ? 'Resume live updates' : 'Pause live updates'
              );
              this.classList.toggle('is-paused', this._userPaused);
              if (this.els.liveLabel) {
                this.els.liveLabel.textContent = this._userPaused
                  ? this.config.pausedLabel
                  : this.config.liveLabel;
              }
              this._syncLoop();
            });
          }

          this._observer = new IntersectionObserver((entries) => {
            this._isIntersecting = entries.some((e) => e.isIntersecting);
            this._syncLoop();
          }, { threshold: 0.1 });
          this._observer.observe(this);

          const onVisibility = () => {
            this._isTabVisible = !document.hidden;
            this._syncLoop();
          };
          document.addEventListener('visibilitychange', onVisibility);
          this._cleanup = () => {
            document.removeEventListener('visibilitychange', onVisibility);
            if (this._observer) this._observer.disconnect();
            this.stopLoop();
          };

        } catch (e) {
          console.warn('Ora Pulse init error:', e);
        }
      }

      disconnectedCallback() {
        if (this._cleanup) this._cleanup();
      }

      _syncLoop() {
        const shouldRun = this._isIntersecting && this._isTabVisible && !this._userPaused;
        if (shouldRun && !this._loopRunning) {
          this.startLoop();
        } else if (!shouldRun && this._loopRunning) {
          this.stopLoop();
        }
      }

      simulateNextTotal() {
        const { productId } = this.config;
        const minTotal = this.isSoldOut ? this.config.soldOutMinTotal : this.config.minTotal;
        const maxTotal = this.isSoldOut ? this.config.soldOutMaxTotal : this.config.maxTotal;
        const seed = productId + this.state.total;
        const r = (opHashCode(seed.toString()) % 10000) / 10000;
        const delta = Math.floor(r * 9) - 4;
        let newTotal = this.state.total + delta;
        const base = minTotal + (opHashCode((productId + 7).toString()) % (maxTotal - minTotal + 1));
        if (Math.abs(newTotal - base) > 8) {
          if (newTotal > base) newTotal -= 1;
          else if (newTotal < base) newTotal += 1;
        }
        return Math.max(minTotal, Math.min(maxTotal, newTotal));
      }

      setTotal(newTotal) {
        this.state.prevTotal = this.state.total;
        this.state.total = newTotal;
        const last = this.state.history[this.state.history.length - 1];
        const next = last + (Math.random() - 0.5) * 8;
        this.state.history.shift();
        this.state.history.push(Math.max(4, Math.min(38, next)));
        this.render(false);
      }

      render(immediate) {
        const { els, state, config, availableSizes } = this;

        opFlipNumber(els.total, String(Math.round(state.total)));

        const newPct = Math.min(96, Math.round(38 + state.total * 1.3));
        opFlipNumber(els.pct, String(newPct));
        state.pct = newPct;

        const counts = opDistribute(state.total, config.weights, availableSizes);
        const hasSizes = availableSizes.length > 0;
        const maxSize = hasSizes
          ? availableSizes.reduce((a, b) => (counts[a] >= counts[b] ? a : b))
          : null;

        if (els.hotSize) {
          if (immediate) {
            els.hotSize.textContent = maxSize || config.soldOutLabel;
          } else {
            els.hotSize.style.transition = 'opacity .4s ease';
            els.hotSize.style.opacity = '0';
            setTimeout(() => {
              els.hotSize.textContent = maxSize || config.soldOutLabel;
              els.hotSize.style.opacity = '1';
            }, 400);
          }
        }

        if (immediate || this._sizeElements.size === 0) {
          if (els.sizesRow) {
            els.sizesRow.innerHTML = '';
            this._sizeFlipEls = new Map();
            availableSizes.forEach((s) => {
              const cell = document.createElement('div');
              cell.className = 'op-size-cell';
              const label = document.createElement('div');
              label.className = 'op-size-label';
              label.textContent = s;
              const count = document.createElement('div');
              count.className = 'op-size-count';
              const flip = document.createElement('span');
              flip.className = 'op-flip';
              count.appendChild(flip);
              cell.appendChild(label);
              cell.appendChild(count);
              els.sizesRow.appendChild(cell);
              this._sizeElements.set(s, cell);
              this._sizeFlipEls.set(s, flip);
            });
          }
        }

        availableSizes.forEach((s) => {
          const count = counts[s];
          const flipEl = this._sizeFlipEls && this._sizeFlipEls.get(s);
          opFlipNumber(flipEl, String(count));
          const cell = this._sizeElements.get(s);
          if (cell) {
            const label = cell.querySelector('.op-size-label');
            const countEl = cell.querySelector('.op-size-count');
            const isHot = s === maxSize;
            if (label) label.style.color = isHot ? 'var(--op-gold)' : 'var(--op-text-faint)';
            if (countEl) countEl.style.color = isHot ? 'var(--op-gold)' : 'var(--op-text-dim)';
          }
        });

        const pts = state.history.map((v, i) => [
          i * (90 / (state.history.length - 1)),
          40 - v - 6
        ]);
        const d = opSmoothPath(pts);
        if (els.line) els.line.setAttribute('d', d);
        if (els.area) els.area.setAttribute('d', d + ' L90,40 L0,40 Z');

        const lastPt = pts[pts.length - 1];
        if (this.animators.dot) this.animators.dot.setTarget(lastPt[0], lastPt[1], immediate);
      }

      pushFeedEvent() {
        if (!this.config.showFeed) return;
        const now = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        const time = pad(now.getHours()) + ':' + pad(now.getMinutes());

        const total = this.state.total;
        let events = [];
        if (total > 50) {
          events = ['added to cart', 'size L selected', 'someone selected M', 'checking out'];
        } else if (total > 25) {
          events = ['someone selected M', 'size S selected', 'browsing gallery', 'added to wishlist'];
        } else {
          events = ['new visitor arrived', 'browsing gallery', 'someone selected S', 'viewing product'];
        }
        const text = events[Math.floor(Math.random() * events.length)];

        const row = document.createElement('div');
        row.className = 'op-feed-row';
        row.innerHTML = '<span class="op-feed-time">' + time + '</span><span>' + text + '</span>';
        if (this.els.feed) {
          this.els.feed.insertBefore(row, this.els.feed.firstChild);
          requestAnimationFrame(() => { row.style.opacity = '1'; });
          while (this.els.feed.children.length > 4) {
            const old = this.els.feed.lastChild;
            old.style.opacity = '0';
            setTimeout(() => old.remove(), 600);
          }
        }
      }

      startLoop() {
        clearInterval(this._mainInterval);
        clearInterval(this._feedInterval);
        this._loopRunning = true;
        if (this.config.showFeed && this.els.feed) {
          this.els.feed.style.display = 'flex';
          this.els.feed.style.flexDirection = 'column';
        }
        this._mainInterval = setInterval(() => {
          this.setTotal(this.simulateNextTotal());
        }, this.config.refreshInterval);
        if (this.config.showFeed) {
          this.pushFeedEvent();
          this._feedInterval = setInterval(() => this.pushFeedEvent(), 4200);
        }
      }

      stopLoop() {
        clearInterval(this._mainInterval);
        clearInterval(this._feedInterval);
        this._loopRunning = false;
      }
    }

    function registerOraPulse() {
      try {
        if (!customElements.get('ora-pulse')) {
          customElements.define('ora-pulse', OraPulse);
        }
      } catch (e) {
        console.warn('Ora Pulse registration failed:', e);
      }
    }

    // ---------- MAIN CARD INIT ----------
    function initCard(component) {
      if (component.dataset.ppcInitialized === 'true') return;
      component.dataset.ppcInitialized = 'true';

      initTabs(component);
      initWishlist(component);
      initModal(component);
      initPillTooltip(component);
      initVariants(component);
      initCart(component);
    }

    // ---------- GLOBAL INIT with Optimised Observer ----------
    function initAll(root) {
      const scope = root || document;
      scope.querySelectorAll('.ppc-card-root').forEach(initCard);
    }

    function getProductContainer() {
      const main = document.querySelector('[data-section-type="product"]') ||
                   document.getElementById('MainProduct') ||
                   document.querySelector('.product') ||
                   document.body;
      return main;
    }

    let observer = null;
    function startObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      const container = getProductContainer();
      observer = new MutationObserver(function(mutations) {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches('.ppc-card-root')) {
              initCard(node);
            }
            if (node.querySelectorAll) {
              const cards = node.querySelectorAll('.ppc-card-root');
              if (cards.length) {
                cards.forEach(initCard);
              }
            }
          });
        }
      });
      observer.observe(container, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        registerOraPulse();
        initAll();
        startObserver();
      });
    } else {
      registerOraPulse();
      initAll();
      startObserver();
    }

    document.addEventListener('shopify:section:load', function(e) {
      registerOraPulse();
      initAll(e.target);
    });
    document.addEventListener('shopify:block:select', registerOraPulse);
  })();
